import { getMomentDate } from '../utils/commonUtils';
import { PAGINATION } from '../constants/Define';
import moment from 'moment';
export default class SaleReportBySKU {
    constructor(data = {}) {
        this.setData(data)
    }
    setData(data = {}) {
        this.pageIndex = data.pageIndex || PAGINATION.pageIndex;
        this.pageSize = data.pageSize || PAGINATION.pageSize;
        this.totalCount = data.totalCount || 0;
        this.totalPage = Math.ceil(parseInt(data.totalCount || 0) / parseInt(data.pageSize || PAGINATION.pageSize));
        // this.startDate = data.startDate ? moment.utc(data.startDate) : moment.utc().startOf('isoWeeks');
        this.startDate = data.startDate ? moment.utc(data.startDate) : moment.utc().subtract('days',7);
        this.endDate = data.startDate ? moment.utc(data.endDate) : moment.utc().endOf('days');
        this.orderBy = data.orderBy;
        this.orderByDesc = data.orderByDesc;
        this.items = data.result && data.result.map(item => new SaleReportBySkuItem(item));
    }

}

export class SaleReportBySkuItem {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined
        this.checkCode = data.checkCode || undefined
        this.checkedBy = data.checkedBy || undefined
        this.checkedDate = data.checkedDate || undefined
        this.couponCode = data.couponCode || undefined
        this.couponValue = data.couponValue || 0
        this.createdDate = data.createdDate || undefined
        this.email = data.email || undefined
        this.firstname = data.firstname || undefined
        this.groupCode = data.groupCode || undefined
        this.id = data.id || undefined
        this.lastname = data.lastname || undefined
        this.name = data.name || undefined
        this.note = data.note || undefined
        this.operaBookingCode = data.operaBookingCode || undefined
        this.orderCode = data.orderCode || undefined
        this.orderItemType = data.orderItemType || undefined
        this.orderStatus = data.orderStatus || undefined
        this.paymentStatus =  data.paymentStatus || 0
        this.paymentType = data.paymentType || undefined
        this.phoneNumber = data.phoneNumber || undefined
        this.price = data.price || 0
        this.property = data.property || undefined
        this.saleChannel = data.saleChannel || undefined
        this.salePrice = data.salePrice || 0
        this.serialNumber = data.serialNumber || undefined
        this.subTotal = data.subTotal || 0
        this.surcharge = data.surcharge || 0
        this.surchargeDetail = data.surchargeDetail || undefined
        this.totalChangeRateCode = data.totalChangeRateCode || undefined
        this.totalAmount = data.totalAmount || 0
        this.transactionId = data.transactionId || undefined
        this.userEmail = data.userEmail || undefined
        this.voucherStatus = data.voucherStatus || undefined
        this.skuCode = data.skuCode || undefined
        this.skuName = data.skuName || undefined
        this.urlSlug = data.urlSlug || undefined
        this.ticketCode = data.ticketCode || undefined
        this.ticketName = data.ticketName || undefined
        this.ticketType = data.ticketType || undefined
        this.checkInDate = data.checkInDate || undefined
        this.checkOutDate = data.checkOutDate || undefined
        this.endDate = data.endDate || undefined
        this.bookingPeriod = data.bookingPeriod || undefined;
        this.channel = data.channel || undefined;
        this.memberShipCode = data.memberShipCode || undefined;
        this.affiliateSource = data.affiliateSource || 'original';
        this.accountantStatus = data.accountantStatus || undefined;
        this.outletName = data.outletName || undefined;
        this.sessionInfo = data.sessionInfo || undefined;
    }
}
